import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetAPINotTreatError = api.create('dponet', false)

const get = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.get(`/company_suppliers/${companySupplierId}`, {
    params,
  })
}

const logs = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.get(`/company_suppliers/${companySupplierId}/logs`, {
    params,
  })
}

const mailLogs = async ({ supplierId = '', ...params }) => {
  return await dponetAPI.get(`/mail_logs`, { params })
}

const create = async (data) => {
  return await dponetAPI.postForm('/company_suppliers', data)
}

const put = async ({ supplierInviteId = '', ...params }) => {
  return await dponetAPI.putForm(
    `/company_suppliers/supplier_invites/${supplierInviteId}`,
    params,
  )
}

const importSuppliers = async (data) => {
  return await dponetAPI.postForm('/company_suppliers/import_suppliers', data)
}

const approveOrRefuse = async ({ supplierId = '', ...params }) => {
  return await dponetAPI.put(
    `/company_suppliers/${supplierId}/approve_or_refuse`,
    params,
  )
}

const supplierIndex = async ({ ...params }) => {
  return await dponetAPI.get('/company_suppliers/iam_supplier/', { params })
}

const clientIndex = async ({ ...params }) => {
  return await dponetAPI.get('/company_suppliers/iam_client/', { params })
}

const reactivate = async ({ companySupplierId, ...data }) => {
  return await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/reactivate`,
    data,
  )
}

const resendEmail = async ({ companySupplierId, ...data }) => {
  return await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/resend_email`,
    data,
  )
}

const inactivate = async ({ companySupplierId }) => {
  return await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/inactivate`,
  )
}

const softDelete = async ({ companySupplierId }) => {
  return await dponetAPI.delete(`/company_suppliers/${companySupplierId}`)
}

const progressStats = async ({ ...params }) =>
  await dponetAPI.get('/company_suppliers/progress_stats', { params })

const stats = async () => {
  return await dponetAPI.get('/company_suppliers/stats')
}

const supplierStats = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.get(
    `/company_suppliers/${companySupplierId}/supplier_stats`,
    {
      params,
    },
  )
}

const accessToSupplierPortal = async ({ companySupplierId = '' }) =>
  await dponetAPINotTreatError.post(
    `/company_suppliers/${companySupplierId}/access_to_supplier_portal`,
  )

const createGeneralInfo = async ({ ...params }) => {
  return await dponetAPI.post('/company_suppliers/general_info', {
    companySupplier: params,
  })
}

const updateGeneralInfo = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/general_info`,
    {
      companySupplier: params,
    },
  )
}

const evaluation = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/evaluation`,
    {
      companySupplier: params,
    },
  )
}

const contract = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.postForm(
    `/company_suppliers/${companySupplierId}/contract`,
    {
      companySupplier: params,
    },
  )
}

const risks = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.post(`/company_suppliers/${companySupplierId}/risks`, {
    companySupplier: params,
  })
}

const upgradePreAvaliation = async ({ companySupplierId = '' }) =>
  await dponetAPI.put(
    `/company_suppliers/${companySupplierId}/pre_avaliation/upgrade`,
  )

const getQuestionnaires = async ({ companySupplierId = '', ...params }) => {
  return await dponetAPI.get(
    `/company_suppliers/${companySupplierId}/company_supplier_questionnaires`,
    { params },
  )
}

const internationalTransferDestroy = async ({
  companySupplierId = '',
  companySupplierDetailId = '',
  internationalTransferId = '',
}) =>
  await dponetAPI.delete(
    `/company_suppliers/${companySupplierId}/company_supplier_details/${companySupplierDetailId}/international_transfers/${internationalTransferId}`,
  )

const partnerExportReport = async ({ ...params }) => {
  return await dponetAPI.post(`/company_suppliers/export_report`, params)
}

const removeUser = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
  companySupplierAuditUserId = '',
  ...params
}) =>
  await dponetAPI.delete(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}/company_supplier_audit_users/${companySupplierAuditUserId}`,
  )

const auditShow = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.get(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}`,
  )

const auditCreate = async ({ companySupplierId = '', ...params }) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audits`,
    { companySupplierAudit: params },
  )

const auditUpdate = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
  ...params
}) =>
  await dponetAPI.put(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}`,
    { companySupplierAudit: params },
  )

const auditDestroy = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.delete(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}`,
  )

const auditInactivate = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}/inactivate`,
  )

const auditReactivate = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}/reactivate`,
  )

const auditFinalize = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}/finalize`,
  )

const auditReopen = async ({
  companySupplierId = '',
  companySupplierAuditId = '',
}) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audits/${companySupplierAuditId}/reopen`,
  )

const auditConfigShow = async ({ companySupplierId = '' }) =>
  await dponetAPI.get(
    `/company_suppliers/${companySupplierId}/company_supplier_audit_configs/show_config`,
  )

const auditConfigCreate = async ({ companySupplierId = '', ...params }) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_audit_configs`,
    { companySupplierAuditConfig: params },
  )

const auditConfigUpdate = async ({
  companySupplierId = '',
  companySupplierAuditConfigId = '',
  ...params
}) =>
  await dponetAPI.put(
    `/company_suppliers/${companySupplierId}/company_supplier_audit_configs/${companySupplierAuditConfigId}`,
    { companySupplierAuditConfig: params },
  )

const createCompanyFragility = async ({ companySupplierId = '', ...data }) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/company_supplier_company_fragilities`,
    { companySupplierCompanyFragility: data },
  )

const destroyCompanyFragility = async ({
  companySupplierId = '',
  companySupplierCompanyFragilityId = '',
}) =>
  await dponetAPI.delete(
    `/company_suppliers/${companySupplierId}/company_supplier_company_fragilities/${companySupplierCompanyFragilityId}`,
  )

const createEvidencePlanAction = async ({ companySupplierId = '', ...data }) =>
  await dponetAPI.postForm(
    `/company_suppliers/${companySupplierId}/evidence_plan_actions`,
    { evidencePlanAction: data },
  )

const updateEvidencePlanAction = async ({
  companySupplierId = '',
  evidencePlanActionId = '',
  ...data
}) =>
  await dponetAPI.putForm(
    `/company_suppliers/${companySupplierId}/evidence_plan_actions/${evidencePlanActionId}`,
    { evidencePlanAction: data },
  )

const destroyEvidencePlanAction = async ({
  companySupplierId = '',
  evidencePlanActionId = '',
}) =>
  await dponetAPI.delete(
    `/company_suppliers/${companySupplierId}/evidence_plan_actions/${evidencePlanActionId}`,
  )

const sendEvidencePlanAction = async ({ companySupplierId = '', ...data }) =>
  await dponetAPI.post(
    `/company_suppliers/${companySupplierId}/evidence_plan_actions/send`,
    data,
  )

export default {
  accessToSupplierPortal,
  approveOrRefuse,
  audits: {
    create: auditCreate,
    destroy: auditDestroy,
    finalize: auditFinalize,
    inactivate: auditInactivate,
    reactivate: auditReactivate,
    reopen: auditReopen,
    show: auditShow,
    update: auditUpdate,
  },
  auditConfigs: {
    show: auditConfigShow,
    create: auditConfigCreate,
    update: auditConfigUpdate,
  },
  clientIndex,
  companyFragilities: {
    create: createCompanyFragility,
    destroy: destroyCompanyFragility,
  },
  contract,
  create,
  evaluation,
  evidencePlanActions: {
    create: createEvidencePlanAction,
    update: updateEvidencePlanAction,
    destroy: destroyEvidencePlanAction,
    send: sendEvidencePlanAction,
  },
  generalInfo: {
    create: createGeneralInfo,
    update: updateGeneralInfo,
  },
  get,
  importSuppliers,
  questionnaires: {
    get: getQuestionnaires,
  },
  inactivate,
  internationalTransfers: {
    destroy: internationalTransferDestroy,
  },
  logs,
  mailLogs,
  partnerExportReport,
  progressStats,
  put,
  resendEmail,
  reactivate,
  removeUser,
  risks,
  softDelete,
  stats,
  supplierStats,
  supplierIndex,
  upgradePreAvaliation,
}
